import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: null,
};

const errorsSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setError, clearError } = errorsSlice.actions;

export const errorState = (state) => state.error.error;

export default errorsSlice.reducer;
